import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { Actions as BAMBOO_ACTIONS } from './store/bambooActions';

import Tooltip from "@/tooltip";
import { ArchiveBoxArrowDownIcon, ArchiveBoxIcon, XMarkIcon } from '@heroicons/react/20/solid';

const ImportDepartmentsModal = ({
    modalOpen,
    closeModal,
    departmentList,
    saveDepartments
}) => {
    const [selectedDepartments, setSelectedDepartmentList] = useState({})
    const selectedDepartmentArray = Object.keys(selectedDepartments || {})
    const selectedDepartmentsLength = selectedDepartmentArray?.length
    useEffect(()=> {
        if(!modalOpen) setSelectedDepartmentList({})
    }, [modalOpen])

    if (!modalOpen) return null

    const importDepartments = (mapDepartments) => {
        saveDepartments(selectedDepartmentArray, mapDepartments)
        setSelectedDepartmentList({})
    }

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b">
                        <div className="block-header bg-primary-dark">
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={() => { closeModal() }}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Import Departments from Bamboo HR</h3>
                        </div>
                        <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
                            {departmentList?.length > 0 ?
                                <>
                                    <table className='js-table-sections table table-hover'>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th width="5%">
                                                    <label className="css-input css-checkbox css-checkbox-success">
                                                        <input
                                                            type="checkbox"
                                                            id={`checkbox-all`}
                                                            checked={selectedDepartmentsLength == departmentList?.length}
                                                            onChange={(e) => {
                                                                const newObject = { ...selectedDepartments }
                                                                departmentList?.map(item => {
                                                                    if (!e.target.checked) delete newObject[item.id]
                                                                    else newObject[item.id] = true
                                                                })
                                                                setSelectedDepartmentList(newObject);
                                                            }}
                                                        />
                                                        <span />
                                                        Select All
                                                    </label>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {departmentList?.map((department) => {
                                                return (
                                                    <tr key={department.id}>
                                                        <td style={{ width: "60%" }}><label htmlFor={`checkbox-${department.id}`}>{`${department.name}`}</label></td>
                                                        <td>
                                                            <label className="css-input css-checkbox css-checkbox-success">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`checkbox-${department.id}`}
                                                                    checked={Object.keys({ ...selectedDepartments }).includes(department.id)}
                                                                    onChange={(e) => {
                                                                        const newObject = { ...selectedDepartments, [department.id]: true }
                                                                        if (!e.target.checked) delete newObject[department.id]
                                                                        setSelectedDepartmentList(newObject);
                                                                    }}
                                                                />
                                                                <span />
                                                            </label>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </>
                                :
                                <div>No Departments Found</div>
                            }
                        </div>
                        <div className="col-xs-12" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                            {selectedDepartmentsLength > 0 ? <>
                                <div className='pull-right'>
                                    <button
                                        type="button"
                                        onClick={() => importDepartments()}
                                        className='btn btn-default'
                                    >
                                        <Tooltip content={'Import Departments from Bamboo HR and create them in Buddy (Do not link automatically)'}>
                                            <ArchiveBoxIcon style={{ height: "1.5em", float: "left" }} />
                                            <div style={{ float: "left", marginLeft: 5 }}>
                                                Import {selectedDepartmentsLength} Department{selectedDepartmentsLength > 1 ? 's' : null}
                                            </div>
                                        </Tooltip>
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => importDepartments(true)}
                                        className='btn btn-success'
                                        style={{ marginLeft: 5 }}
                                    >
                                        <Tooltip content={'Create Departments in Buddy and link them to their Bamboo HR counterparts in settings'}>
                                            <ArchiveBoxArrowDownIcon style={{ height: "1.5em", float: "left" }} />
                                            <div style={{ float: "left", marginLeft: 5 }}>
                                                Import {selectedDepartmentsLength} Department{selectedDepartmentsLength > 1 ? 's' : null} & Map Fields
                                            </div>
                                        </Tooltip>
                                    </button>
                                </div>
                            </>
                                :
                                <button
                                    type="button"
                                    className="pull-right btn btn-default"
                                    onClick={() => closeModal()}
                                >
                                    Close
                                </button>
                            }
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    const { bambooHr } = { ...state.integration?.hris }
    const departmentField = bambooHr?.settings?.mappedFields?.['Role Details']?.department
    const existingDepartments = state.company?.settings?.departments?.map(item => item.bambooReference)
    const departmentList = bambooHr?.options?.bambooFields?.find(item => item.id == departmentField)?.subOptions?.filter(item => !existingDepartments?.includes(item.name))
    return {
        modalOpen: bambooHr?.importDepartmentsModal,
        departmentList: departmentList,
        existingDepartments
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(BAMBOO_ACTIONS.importDepartmentsModal(false)),
    saveDepartments: (departments, mapDepartments) => dispatch(BAMBOO_ACTIONS.saveDepartments(departments, mapDepartments)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportDepartmentsModal) 
